/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityByAgeWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityByAgeWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilityByAgeWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityByAgeWidgetConfiguration>): VulnerabilityByAgeWidgetConfiguration {
        let obj = Object.assign(new VulnerabilityByAgeWidgetConfiguration(), model);
        VulnerabilityByAgeWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityByAgeWidgetConfiguration>): VulnerabilityByAgeWidgetConfiguration {
        if (!model) return null;
        return VulnerabilityByAgeWidgetConfiguration.newInstance(<VulnerabilityByAgeWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityByAgeWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilityByAgeWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityByAgeWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityByAgeWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
